<!--推荐主题活动-->
<template>
    <div class="app-container">
        <el-card v-has-btn="'1,2,'" class="mb15">
            <el-row>
                <el-col :span="16" class="mb0">
                    <el-button v-has-btn="'1,2'" @click="handleCreate" type="primary">新增实践活动</el-button>
                </el-col>
            </el-row>
        </el-card>

        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="60px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="年级">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in eventGradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="上下册">
                            <el-select clearable @change="pageList(null)" v-model="queryParams.practiceGrade" placeholder="请选择上下册">
                                <el-option v-for="item in volumeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mr0 mb0">

                    </el-col>
                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.practiceName" placeholder="请输入名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                          :height="`calc(100vh - 340px)`"
                          v-loading="loading" :data="dataList" highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column  label="名称" align="center" prop="eventTheme">
                        <template #default="scope">
                            <div :title="scope.row.practiceName" @click="handleView(scope.row)" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.practiceName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="140" label="年级" align="center" prop="">
                        <template #default="scope">
                            <div :title="scope.row.gradeName"
                                 class="text-one cursor">
                                {{ scope.row.gradeName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" label="上下册" align="center" prop="">
                        <template #default="scope">
                            <div :title="scope.row.practiceGradeName"
                                 class="text-one cursor">
                                {{ scope.row.practiceGradeName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="140" label="创建时间" align="center" prop="createTime">
                        <template #default="scope">
                            <div>{{ timestampToTime(scope.row.createTime) }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100" align="center" label="操作"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="80" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleView(scope.row)">查看</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                        </div>
                                        <div class="text-item">
                                            <el-popconfirm
                                              confirm-button-text="是"
                                              cancel-button-text="否"
                                              :icon="InfoFilled"
                                              icon-color="#626AEF"
                                              title="确定删除?"
                                              @confirm="handleDelete(scope.row)">
                                                <template #reference>
                                                    <el-text type="danger">删除</el-text>
                                                </template>
                                            </el-popconfirm>
                                        </div>

                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]" :total="total"
                            :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="pageList" />
            </div>
        </el-card>


    </div>
</template>
<script>
import { queryDict } from "@/api/admin/public";
import {pagePractice,deletePractice} from "@/api/admin/practice"
import {timestampDate, timestampToTime} from "@/utils/date";
export default {
    name: "practiceIndex",
    components: {},
    data() {
        return {
            timestampToTime,
            timestampDate,
            loading: false,
            periodList:[],
            gradeList:[],
            itemList:[],
            typeList: [
                { name: '音乐', value: 1 },
                { name: '美术', value: 2 },
                { name: '主题班会', value: 3 },
            ],
            dataList:[],
            total:0,
            queryParams:{
                practiceName:'',
                practiceGrade:'',
                periodKey:'',
                gradeKey:'',
                pageNum: 1,
                pageSize: 10,
            },
            eventGradeList:[],
            volumeList:[],
        };
    },
    created() {
        this.getQueryDict();
        this.pageList();
    },
    activated() {},
    watch: {},
    methods: {
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageList(null)
        },
        getQueryDict() {
            queryDict({ code: 'event_grade' }).then(res => {
                this.eventGradeList = res.data.data;
            })
            queryDict({ code: 'volume_type' }).then(res => {
                this.volumeList = res.data.data;
            })
        },
        handleCreate(){
            this.$router.push({
                path: "/practiceCreate",
            });
        },
        handleUpdate(row){
            this.$router.push({
                path: "/practiceCreate",
                query: {
                    practiceId: row.practiceId,
                }
            });
        },
        handleDelete(row){
            deletePractice({ practiceId: row.practiceId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.pageList(null);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pagePractice(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        handleView(row){
            this.$router.push({
                path: "/practiceCreate",
                query: {
                    practiceId: row.practiceId,
                }
            });
        }
    }
}
</script>

<style scoped>
/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}
</style>